import { lazy } from 'react';

const ProductList = lazy(() => import('./product-list'));;

export default {
  ProductList,
};
